import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UltimatePagination from 'react-ultimate-pagination-bootstrap-4';

import TitleBar from 'components/title_bar';
import LoadingSpinner from 'components/loading_spinner';
import AggregateView from 'components/importer/aggregate_view';
import Table from './table';
import EmptyState from 'shared/empty_state';

import { post } from 'helpers/api';
import { retrieveImports } from '../store/actions/search';
import { changeImportPage } from '../store/actions/query';
import { getImports, isFetching } from '../store/selectors/search';
import { getImportsPath } from '../store/selectors/paths';
import { getAggregateView } from '../store/selectors/static';
import { getCurrentPage, getTodalPages } from '../store/selectors/search';

export function ImportsList({
  aggregateView,
  currentPage,
  imports,
  importsPath,
  isFetching,
  onPageChange,
  retrieveRecords,
  totalPages
}) {
  useEffect(() => {
    !aggregateView && retrieveRecords();
  }, []);

  const handleNewImport = () => {
    const params = { importerImport: { ownerType: 'data_imports_team' } };

    post(importsPath, params).then((response) => {
      window.location.href = response.import.importPath;
    });
  };

  const handlePageChange = (page) => {
    onPageChange(page);
    retrieveRecords();
  };

  const renderResults = () => {
    if (isFetching) {
      return <LoadingSpinner/>;
    } else if (imports.length > 0) {
      return <Table imports={imports} />;
    }
    return (
      <EmptyState
        buttonText="Start your first import"
        header="You haven't imported anything yet"
        onClick={handleNewImport}
      />
    );
  };

  const renderPagination = () => {
    if (isFetching || totalPages <= 1)  {
      return null;
    }

    return (
      <div className="text-center">
        <UltimatePagination
          currentPage={currentPage}
          totalPages={totalPages}
          onChange={handlePageChange}
        />
      </div>
    );
  };

  const renderBody = () => {
    if (aggregateView) {
      return <AggregateView/>;
    }
    return renderResults();
  };

  return (
    <>
      <TitleBar
        subtitle="Import contacts, companies and properties"
        title="Imports"
      >
        {
          !aggregateView &&
          <button className="btn btn-primary" name="new-import" onClick={handleNewImport}>
            New Import
          </button>
        }
      </TitleBar>

      <div className="container bg-white shadow px-6 py-4">
        {renderBody()}
        {renderPagination()}
      </div>
    </>
  );
}

ImportsList.propTypes = {
  aggregateView: PropTypes.bool.isRequired,
  currentPage: PropTypes.number.isRequired,
  imports: PropTypes.array.isRequired,
  importsPath: PropTypes.string.isRequired,
  isFetching: PropTypes.bool.isRequired,
  retrieveRecords: PropTypes.func.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  aggregateView: getAggregateView(state),
  currentPage: getCurrentPage(state),
  imports: getImports(state),
  importsPath: getImportsPath(state),
  isFetching: isFetching(state),
  totalPages: getTodalPages(state)
});

const mapDispatchToProps = {
  onPageChange: changeImportPage,
  retrieveRecords: retrieveImports
};

export default connect(mapStateToProps, mapDispatchToProps)(ImportsList);
